/**
 * App entry point
 *
 * - Loads `app.tsx`, which mounts the UI and emits "ui-ready"
 * - Waits for "ui-ready" before loading `main.app.ts` to ensure no events are missed
 * - Emits "load" after receiving the "initialized" event triggered by app.init()
 * - Initializes Sentry in production
 */

import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";

import("./app");

emitter.on("ui-ready", () => {
  import("./main.app.ts");
});

//----------------------------------------------------------------

emitter.on("initialized", () => {

});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://11cc05d2aa91c0dd7c692dcd62601dd1@o1388406.ingest.us.sentry.io/4510100628963328",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}
